import { IItemCacheThunkAction } from '@ms/items-view/lib/private/store/actions/ItemCacheActions';
import { itemsViewSearchControl } from '@ms/items-view/lib/private/controls/itemsViewSearchControl';
import {
  IControlHandler,
  createControlHandler
} from '@ms/items-view/lib/private/addons/registerControlHandler';
import { IItemCache } from '@ms/items-view/lib/private/models/IItemCacheObserver';
import { IItemCacheDispatch } from '@ms/items-view/lib/private/store/actions/ItemCacheActions';
import { spFolderItemSetKeyFacet, spSearchItemSetKeyFacet } from '../dataSource/Keys';

function getSearchItemKeyFacet(
  spItemSetSearchKey: typeof spFolderItemSetKeyFacet.type | typeof spSearchItemSetKeyFacet.type,
  query: string | undefined
): string {

  // Search is done within the document library and not the current root folder
  return spSearchItemSetKeyFacet.serialize({
    ...({
      ...spItemSetSearchKey,
      searchTerm: query
    })
  });
}

/**
 * Initializer for a control handler which lets the SharePoint addon override and extend items view to show search.
 */
export const itemsViewSearchControlHandler:
  IControlHandler<typeof spFolderItemSetKeyFacet.type, typeof itemsViewSearchControl.type> =
  createControlHandler()(getItemsViewSearchControlHandler);

export const searchViewSearchControlHandler:
  IControlHandler<typeof spSearchItemSetKeyFacet.type, typeof itemsViewSearchControl.type> =
  createControlHandler()(getItemsViewSearchControlHandler);

function getItemsViewSearchControlHandler(): IItemCacheThunkAction<typeof itemsViewSearchControl.type> {
  return (dispatch: IItemCacheDispatch) => {
    return (itemCache: IItemCache, props: typeof itemsViewSearchControl.inputType): typeof itemsViewSearchControl.returnType => {
      const {
        itemKey
      } = props;

      let spItemSetSearchKey = itemCache.demandItemFacet(spFolderItemSetKeyFacet, itemKey);
      let searchKeyFunc;
      if (spItemSetSearchKey) {
        searchKeyFunc = (query: string | undefined): string | undefined => {
          return (spItemSetSearchKey) ? getSearchItemKeyFacet(spItemSetSearchKey, query) : undefined;
        };
      } else {
        let spSearchItemSetSearchKey = itemCache.demandItemFacet(spSearchItemSetKeyFacet, itemKey);
        searchKeyFunc = (query: string | undefined): string | undefined => {
          return (spSearchItemSetSearchKey) ? getSearchItemKeyFacet(spSearchItemSetSearchKey, query) : undefined;
        };
      }

      return {
        isAvailable: true,
        getSearchItemKey: searchKeyFunc
      };
    };
  };
}
